import { CommandFn, CommandOptions } from '../../commands';

export const fn: CommandFn = (opts: CommandOptions): void => {
}
